<template>
  <div class="header-navigation">
    <v-btn v-for="item in navigation"
           :key="item.value"
           text small
           :class="{ 'tw-text-primary': activePage === item.value}"
           class="tw-font-normal"
           @click="$router.push({name: item.url})"
    >
      {{ item.value }}
    </v-btn>
  </div>
</template>

<script>
import headerNavigation from '@/common/data/globalHeaderNavigation'

export default {
  name: 'DefaultHeaderNavigation',
  computed: {
    activePage () {
      return 'County'
    }
  },
  data: function () {
    return {
      navigation: headerNavigation
    }
  }
}
</script>

<style scoped>

</style>
